/* =====================================
*  採用情報ページのJS定義
* ===================================== */





// 採用情報メインの画像表示をPCとスマホで変更する
document.addEventListener("DOMContentLoaded", function() {
  function moveRecruiteFig() {
    const figElement = document.querySelector('.recruite--main .recruite--swiper');
    const titElement = document.querySelector('.cmn__recruite--tit');
    if (window.innerWidth <= 790 && figElement && titElement) {
      const clonedFig = figElement.cloneNode(true);
      titElement.insertAdjacentElement('afterend', clonedFig);
      figElement.remove();
    }
  }
  window.addEventListener('resize', moveRecruiteFig);
  moveRecruiteFig();
});





// recruiteのswiperスライド
document.addEventListener('DOMContentLoaded', function () {
  function initOrDestroySwiper() {
    var screenWidth = window.innerWidth;
    var swiperContainer = document.querySelector('.recruite--swiper');
    var topSwiperKitchencar;
    if (screenWidth >= 790) {
      topSwiperKitchencar = new Swiper('.recruite--swiper', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 24,
        centeredSlides: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: 2500,
        freeMode: true,
        freeModeMomentum: false,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
      });
    }
    if (screenWidth < 790 && swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }
  }
  initOrDestroySwiper();
  window.addEventListener('resize', function () {
    initOrDestroySwiper();
  });
});